import { CellCoordsObj, CellData } from '../../../../../../common/table/TableTypes';
import { CellTypeNames } from '../../../../../../common/table/CellTypeConstants';
import {
    getSharedFormattingValuesFromCellTypes,
    updateCellTypeFromComputedValue,
} from '../../dataUtils/cell/tableCellTypeUtils';
import { getNormalisedComputedCellValueFromHot } from './hotTableCellRenderValueUtils';
import { getHotTableCellData } from '../meta/hotTableCellMetaUtils';
import type { MNHotInstance } from '../../../tableHotInstanceTypes';

/**
 * Returns the shared formatting state for the current HoT selection.
 */
export const getSharedFormattingValuesFromHot = (
    hotInstance: MNHotInstance | null | undefined,
    allSelectedCells: Array<CellCoordsObj>,
) => {
    if (!hotInstance || !allSelectedCells || allSelectedCells.length === 0) return;

    const selectedCellsTypes = allSelectedCells.map(
        ({ row, col }) => getHotTableCellData(hotInstance, { row, col })?.type,
    );

    return getSharedFormattingValuesFromCellTypes(selectedCellsTypes);
};

/**
 * Updates a cell type using live HoT data needed to validate formula-backed values.
 */
export const updateCellType = (
    prevCellData: CellData,
    cellTypeName: CellTypeNames,
    currencyPreference: string,
    elementId: string,
    row: number | undefined,
    col: number | undefined,
    hot: MNHotInstance | null | undefined,
): CellData => {
    if (!hot) return prevCellData;

    const { locale } = hot.milanoteProps;
    const normalisedComputedCellValue = getNormalisedComputedCellValueFromHot(elementId, row, col, hot);

    return updateCellTypeFromComputedValue(
        prevCellData,
        cellTypeName,
        currencyPreference,
        locale,
        normalisedComputedCellValue,
    );
};
